<div
  class="d-flex flex-wrap p-4 layout-bg align-items-center justify-content-center vh-100"
>
  <div class="text-center">
    <h1 class="display-1 fw-bold">404</h1>
    <p class="fs-3"><span class="text-danger">Opps!</span> Page not found.</p>
    <p class="lead">ไม่พบหน้าที่ท่านต้องการ กรุณาตรวจสอบใหม่อีกครั้ง</p>

    <div class="d-flex flex-wrap gap-3 justify-content-center">
      <button
        type="button"
        class="btn btn-outline-primary go-back"
        style="min-width: 168px"
        (click)="goBack()"
      >
        กลับไปหน้าก่อนหน้า
      </button>

      <button
        routerLink="/"
        type="button"
        class="btn btn-primary"
        style="min-width: 168px"
      >
        กลับสู่หน้าหลัก
      </button>
    </div>
  </div>
</div>
